import { CartLinesUpdateEvent } from '@shopify/events';
let busy = false;
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.purebau-rec-add')) return;
  event.preventDefault();
  if (busy || !form.reportValidity()) return;
  const field = form.elements.namedItem('id');
  const id = field?.value;
  if (!id) return;
  const quantity = Number(field.selectedOptions?.[0]?.dataset.min || field.dataset.min) || 1;
  const button = form.querySelector('button');
  const status = form.querySelector('[role="status"]');
  const root = window.Shopify?.routes?.root || '/';
  busy = true; button.disabled = true; button.textContent = 'Adding...'; status.textContent = '';
  let added = false;
  try {
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
    const response = await fetch(root + 'cart/add.js', {
      method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(id),quantity}],sections:sections.join(','),sections_url:location.pathname})
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item.');
    added = true;
    const cartResponse = await fetch(root + 'cart.js', {credentials:'same-origin'});
    if (!cartResponse.ok) throw new Error('Item added. Please refresh to see your updated cart.');
    const cart = await cartResponse.json();
    form.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'cart',lines:[{merchandiseId:id,quantity}],promise:Promise.resolve({
      cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail:{sections:result.sections,items:cart.items,itemCount:quantity,productId:form.dataset.productId,source:'purebau-recommendation-add',didError:false}
    })}));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    status.textContent = 'Added to your cart'; button.textContent = 'Added';
  } catch(error) {
    status.textContent = added ? 'Item added. Please refresh to see your updated cart.' : (error.message || 'Connection problem. Check your cart before trying again.');
    button.textContent = added ? 'Added' : '+ ADD';
  } finally { busy = false; if (!added) button.disabled = false; }
});
